import { toast } from "sonner";
import { api } from "@/lib/api";

// Owner buys 100 extra Edgar AI answers or voice lines (Stripe checkout, never expire, shared with the team).
export async function buyPack(kind) {
  try {
    const { data } = await api.post("/edgar/packs/checkout", { kind, origin_url: window.location.origin });
    window.location.assign(data.checkout_url);
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Couldn't start checkout");
  }
}
